<div class="dialog-container">
    <button mat-icon-button class="close-button" id="close-button" mat-dialog-close type="button">
        <fa-icon icon="times" />
    </button>
    <div mat-dialog-title class="app-header">
        {{ data.header.title }}
    </div>
    <mat-form-field>
        <mat-select [ngModel]="selectedFilter$ | async" (selectionChange)="selectedFilter$.next($event.value)">
            @for (date of dateFilters; track $index) {
                <mat-option [value]="date[1].toISO()">{{ date[0] }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <div mat-dialog-content class="body-container">
        @if (groupedCounts().length === 0) {
            <div>There are no results.</div>
        } @else {
            <r1-compass-app-sum-bar-chart [chartData]="groupedCounts()" />
        }
    </div>
</div>
